/**
 * 内部渠道
 */
export var PromotionInternalChannel;
(function (PromotionInternalChannel) {
    PromotionInternalChannel["DEFAULT"] = "default";
    PromotionInternalChannel["WX_CHATBOT_SALE"] = "wx-chatbot-sale";
    PromotionInternalChannel["WX_MENU_SALE"] = "wx-menu-sale";
    PromotionInternalChannel["WX_MENU_GROWTH"] = "wx-menu-growth";
    PromotionInternalChannel["WX_SHARE_SALE"] = "wx-share-sale";
    PromotionInternalChannel["WX_SHARE_GROWTH"] = "wx-share-growth";
    PromotionInternalChannel["WX_QR_GROWTH"] = "wx-qr-growth";
    PromotionInternalChannel["WX_QR_GAME_TEST"] = "wx-qr-game-test";
    PromotionInternalChannel["WX_QR_CERTIFICATE"] = "wx-qr-certificate";
    PromotionInternalChannel["WX_GROUP_SALE"] = "wx-group-sale";
    PromotionInternalChannel["WX_POST_SALE"] = "wx-post-sale";
    PromotionInternalChannel["WX_QR_EULER_QUIZ"] = "wx-qr-euler-quiz";
    PromotionInternalChannel["WX_QR_EULER_MATCH_RESULT"] = "wx-qr-euler-match-result";
    PromotionInternalChannel["WX_SHARE_EULER_QUIZ"] = "wx-share-euler-quiz";
    PromotionInternalChannel["WX_SHARE_EULER_MATCH_RESULT"] = "wx-share-euler-match-result";
    PromotionInternalChannel["WX_QR_SLM_SHARE"] = "wx-qr-slm-share";
    PromotionInternalChannel["WX_SHARE_SLM_COUPON"] = "wx-share-slm-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_RELATIONSHIPS"] = "wx-share-slm-relationships";
    PromotionInternalChannel["WX_SHARE_GROUPON_PURCHASE"] = "wx-share-groupon-purchase";
    PromotionInternalChannel["WX_SHARE_C9X_GROUPON_PURCHASE"] = "wx-share-c9x-groupon-purchase";
    PromotionInternalChannel["WX_QR_SLM_POINT_SHARE"] = "wx-qr-slm-point-share";
    PromotionInternalChannel["WX_SHARE_SLM_POINT_COUPON"] = "wx-share-slm-point-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_POINT_RELATIONSHIPS"] = "wx-share-slm-point-relationships";
    PromotionInternalChannel["WX_SHARE_POINT_HOME"] = "wx-share-point-home";
    PromotionInternalChannel["WX_SHARE_C3_SALE"] = "wx-share-c3-sale";
    PromotionInternalChannel["WX_SHARE_C3_SHARE"] = "wx-share-c3-share";
    PromotionInternalChannel["WX_QR_C3_SHARE"] = "wx-qr-c3-share";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3_QR"] = "wx-custom-share-c3-qr";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3_SHARE"] = "wx-custom-share-c3-share";
    PromotionInternalChannel["WX_SHARE_C3_GROWTH"] = "wx-share-c3-growth";
    PromotionInternalChannel["WX_QR_C3_GROWTH"] = "wx-qr-c3-growth";
    PromotionInternalChannel["WX_QR_SLM_C9X_SHARE"] = "wx-qr-slm-c9x-share";
    PromotionInternalChannel["WX_SHARE_SLM_C9X_COUPON"] = "wx-share-slm-c9x-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_C9X_RELATIONSHIPS"] = "wx-share-slm-c9x-relationships";
    PromotionInternalChannel["WX_SHARE_C9X_SALE"] = "wx-share-c9x-sale";
    PromotionInternalChannel["WX_SHARE_C3X_SALE"] = "wx-share-c3x-sale";
    PromotionInternalChannel["WX_SHARE_C3X_SHARE"] = "wx-share-c3x-share";
    PromotionInternalChannel["WX_QR_C3X_SHARE"] = "wx-qr-c3x-share";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3X_QR"] = "wx-custom-share-c3x-qr";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3X_SHARE"] = "wx-custom-share-c3x-share";
    PromotionInternalChannel["WX_SHARE_C99X_SALE"] = "wx-share-c99x-sale";
    PromotionInternalChannel["WX_SHARE_C99X_GROUPON_PURCHASE"] = "wx-share-c99x-groupon-purchase";
    PromotionInternalChannel["WX_SHARE_SLM_C99X_COUPON"] = "wx-share-slm-c99x-coupon";
    PromotionInternalChannel["WX_QR_SLM_C99X_SHARE"] = "wx-qr-slm-c99x-share";
    PromotionInternalChannel["WX_SHARE_APPLY_FREE_LESSON"] = "wx-share-apply-free-lesson";
    PromotionInternalChannel["WX_APPLY_FREE_LESSON_DOWNLOAD_GUIDE"] = "wx-apply-free-lesson-download-guide";
    PromotionInternalChannel["WX_SHARE_CERTIFICATE"] = "wx-share-certificate";
})(PromotionInternalChannel || (PromotionInternalChannel = {}));
//# sourceMappingURL=promotion.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/types/promotion.js
// module id = 1222
// module chunks = 0